import { Component, EventEmitter, HostListener, Input, OnInit, AfterViewInit, Output, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { ControllerService } from '../services/controller.service';
import { KHASystemService } from '../services/systems/kha-systems.service';
import { CommunicationService } from "../services/communication.service";
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ChitService } from '../services/chit.service';
import { TagService } from '../services/tag.service';
import { DrawService } from '../services/draw.service';
import { SocketService } from '../services/socketService';
import { RadhazVisService } from "../services/radhaz.service";
import { ActivityVisualizationService } from '../services/activity-visualization.service';

import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-ship-detail',
  templateUrl: './ship-detail.component.html',
  styleUrls: ['./ship-detail.component.scss'],
  providers: [DatePipe]
})
export class ShipDetailComponent implements OnInit {
  cfbport: string;
  @Input() mvScreenType: any = "compartment";
  @Input() compToggle: any;
  @Input() set appMode(v: any) {
    if (v == 'mepm') {
      this.cfbport = 'slms'
    } else {
      this.cfbport = v;
    }
  }
  dfx;
  ship_settings = {
    "mats": "./systems_material.gltf",
    "ernmodel": "./ern_fleetway_halifax.glb"
  }
  ship_objects = {
    "shapes": [
      {
        "mhfx": {
          "model": "root_kys_halifax",
          "material": "custom-included",
          "size": 1
        }
      },
      {
        "ernhfx": {
          "model": "root_ern_fleetway_halifax",
          "material": "custom-included",
          "size": 1
        }
      }
    ],
    "objects": [
      {
        "type": "static",
        "parent": "",
        "name": "ehfx",
        "model": "mhfx",
        "place": {
          "pos": {
            "x": 0,
            "y": 0,
            "z": 0
          },
          "rot": {
            "x": 0,
            "y": 0,
            "z": 0
          }
        }
      },

      {
        "type": "static",
        "parent": "",
        "name": "ernhfx",
        "model": "ernhfx",
        "place": {
          "pos": {
            "x": 0,
            "y": 0,
            "z": 0
          },
          "rot": {
            "x": 0,
            "y": 0,
            "z": 0
          }
        }
      }
    ]
  }
  ship_settings_slms = {
    "kys": "./slms/kys_halifax.glb",
    "ernmodel": "./slms/ern_fleetway_halifax.glb"
  }
  ship_settings_slms_thumb = {
    "mats": "./systems_material.gltf",
    "kys": "./slms/kys_hfx_thumb.glb",
    "ealoft": "./slms/envelope-aloft.glb"
  }
  ship_objects_thumb = {
    "shapes": [
      {
        "mhfx": {
          "model": "root_kys_hfx_thumb",
          "material": "custom-included",
          "size": 1
        }
      },
      {
        "maloft": {
          "model": "WARNINGS",
          "material": "custom-included",
          "size": 1
        }
      }
    ],
    "objects": [
      {
        "type": "static",
        "parent": "",
        "name": "ehfx",
        "model": "mhfx",
        "place": {
          "pos": {
            "x": 0,
            "y": 0,
            "z": 0
          },
          "rot": {
            "x": 0,
            "y": 0,
            "z": 0
          }
        }
      },
      {
        "type": "static",
        "parent": "",
        "name": "ealoft",
        "model": "maloft",
        "place": {
          "pos": {
            "x": 0,
            "y": 5,
            "z": -65.5
          },
          "rot": {
            "x": 0,
            "y": 0,
            "z": 0
          }
        }
      }
    ]
  }
  cam_mode = '3D';
  isMouseDown
  mousestate = "up";
  doubleClick = 0;
  allShipElements: any;
  khaConfig
  lightSettings;
  scene;
  slms_mode = true;
  selectedKha: any = "compartments";
  initialized = false;
  isMaterialAppLoaded: boolean = false;
  projectConfig: any;
  selectedKhaSystems: any;
  arrControlBtnProps = [
    { name: 'home', icon: 'home', state: true },
    { name: '2D', icon: 'dimension', state: false },
    { name: 'zoomin', icon: 'add', state: true },
    { name: 'zoomout', icon: 'remove', state: true },
    { name: 'drag', icon: 'swipe', state: false, ticon: 'do_not_touch' },
    { name: 'reset', icon: 'refresh', state: false, ticon: 'refresh' },
    { name: 'marker', icon: 'marker', state: false, ticon: '' },
    { name: 'cutmarker', icon: 'create', state: false, ticon: '' },
    { name: 'screenshot', icon: 'screenshot_monitor', state: false, ticon: 'screenshot_monitor' },
    { name: 'stateBoard', icon: 'grid_on', state: false, ticon: 'grid_off', tooltip: "Stateboard" }
    // { name: 'exit', icon: 'exit_to_app', state: false, ticon: 'exit_to_app' }
  ];
  shipCompartment: any;
  camviews = "";
  selectedDemo: string = "";
  broadcastSubs: any;
  khaComps: any;
  gameManager;
  drawing = false;
  markerShape = 'rect'
  pickedMeshObj: any;
  selectedMesh: any;
  markerColor = "#ff0000";
  markerWidth = 1;
  fillStatus: boolean = false;
  mname: any;
  highlightCompState = false;
  materialmap: any = {};
  statusMode: boolean = false;
  selectedStatus: any = '';
  compartmentLoad: any;
  selectedLayoutList: any;
  shapeCollection: any;
  shapeCollectionIcon: any;
  shapeCollectionImg: any;
  layoutShapeModel = false;
  typeCollection: any;
  groupCollection: any;
  groupCollectionData: any = [];
  statusCollection: any;
  statusCollectionData: any = [];
  saveLayoutData: any = {};
  layoutHeadingName: any;
  last_pick_pt = null;

  navyFilterState: any;
  broadcastIframeSubs: any;
  userId: any = '';
  userName: any = '';
  accountEmail: any = '';
  loginInfo: any = {};
  userRole: any;
  vesselLoading: boolean = false;
  @ViewChild('datauxview', { static: true }) public datauxview: any;
  usersDetails: any = [];
  project_config: any;
  iframe_cd_ready: boolean = false;
  iframeInView: boolean = false;
  dockyardView = false;
  constructor(
    private configService: ConfigService,
    private ctrlServ: ControllerService,
    private _khaConfig: KHASystemService,
    private CommunicationServ: CommunicationService,
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private chitService: ChitService,
    private drawService: DrawService,
    private tagServ: TagService,
    private socketService: SocketService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private snackbar: MatSnackBar,
    private radhazVisServ: RadhazVisService,
    private activityServ: ActivityVisualizationService,
    public dialog: MatDialog,
  ) {
    this.matIconRegistry.addSvgIcon(
      `hexagon-icon`,
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/hexagon-icon.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `hexagon-icon-active`,
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/hexagon-icon-active.svg")
    );
    this.khaConfig = this._khaConfig;
    this.khaComps = this.ctrlServ.comps;
  }
  /* * * * *
  * method for communicate event instance with data to access all components
  * * * * * */
  broadcastInfo(data: any) {
    this.CommunicationServ.getInstance().next(data);
  }

  broadcastIframeInfo(data: any) {
    this.CommunicationServ.createIframeInstance(data);
  }

  buttonclick(row, index) {
    this.arrControlBtnProps[index].state = !this.arrControlBtnProps[index].state;
    this.controlToolEvent(row);
  }

  controlToolEvent(control) {
    if (control.name === 'home') {
      let currentTab = this.ctrlServ.matCurrentTab;
      if (currentTab === 'compartment') {
        if (this.camviews) {
          this.moveCameraTo(null, this.camviews);
        } else {
          this.onChangeCameraPosition(control.name);
        }
      } else {
        this.onChangeCameraPosition(control.name);
      }
    } else if (control.name === '2D') {
      let dimension = control.state ? '2D' : '3D';
      this.onChangeCameraMode(dimension);
    } else if (control.name === 'zoomin' || control.name === 'zoomout') {
      let zoomPosition = control.name === 'zoomin' ? ']' : '[';
      this.Zoom(zoomPosition);
    } else if (control.name === 'drag') {
      if (control.state) {
        this.khaConfig.dragMode = true;
        this.khaConfig.enableDrag();
      } else {
        this.khaConfig.dragMode = false;
        this.khaConfig.removeDragAll();
      }
    } else if (control.name === 'reset') {
      this.khaConfig.clearDrag();
      if (this.arrControlBtnProps[4].state) {
        this.khaConfig.enableDrag();
      }
    } else if (control.name === 'marker') {
      this.drawService.draw_select_mode = this.arrControlBtnProps[6].state;
      if (this.drawService.draw_select_mode) {
        this.arrControlBtnProps[7].state = !this.drawService.draw_select_mode;
        this.drawService.cut_mode = !this.drawService.draw_select_mode;
      }
    } else if (control.name === 'cutmarker') {
      this.drawService.cut_mode = this.arrControlBtnProps[7].state;
      if (this.drawService.cut_mode) {
        this.arrControlBtnProps[6].state = !this.drawService.cut_mode;
        this.drawService.draw_select_mode = !this.drawService.cut_mode;
      }
    } else if (control.name == 'exit') {
      this.arrControlBtnProps[9].state = !this.arrControlBtnProps[9].state;
      this.broadcastInfo({ src: 'sidepanel', event: 'exit', data: this.arrControlBtnProps[9].state, comp: [] });
    } else if (control.name === 'stateBoard') {
      console.log("stateBoard", control);
      if (control.state) {
        this.broadcastInfo({ src: 'sidepanel', event: 'stateBoardData', data: "stateBoardCtrl" });
        this.userRole = this.configService['loginInfo']['role'];
      } else {
        delete this.userRole;
      }
      // setTimeout(() => {
      this.broadcastInfo({ src: 'sidepanel', event: 'stateBoardClose', data: control.state, key: this.userRole });
      // }, 5500);
    }
  }
  ngOnInit(): void {
    this.vesselLoading = true;
    this.getUserData();
    this.broadcastSubs = this.CommunicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "khaservice") {
          if (data.event === 'showloader') {
            let obj = data['data'];
            // this.showLoading = true;
            // this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });
            this.selectedDemo = obj;
          }
          if (data.event === 'hideloader') {
            let obj = data['data'];
            // this.showLoading = !true;
            // this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });
            this.selectedDemo = "";
            if (obj) {
              this.shipCompartment = obj;
            }
          }
          if (data.event === 'updatehomeview') {
            if (data['data']) {
              this.camviews = data['data'];
            }
          }
        }
        if (data.src === "controlpanel") {
          if (data.event === 'reset_drag') {
            if (data['key']) {
              this.shipCompartment = (data['key'] === 'system' ? null : this.shipCompartment);
            }
          }
          if (data.event === "reset_drag") {
            if (this.arrControlBtnProps[4].state) {
              this.arrControlBtnProps[4].state = !this.arrControlBtnProps[4].state;
              this.khaConfig.dragMode = false;
              this.khaConfig.clearDrag();
            }
          }
          if (data.event == 'showhidesubsystem') {
            if (!data.data && this.selectedKhaSystems) {
              if (data.key[0] == this.selectedKhaSystems.model[0]) {
                this.khaConfig.showMatObjectTag(null, false);
              }
            }
          }
        }
        if (data.src === "sidepanel") {
          if (data.event === 'init') {
            this.onSidePanelInit()
          }
          if (data.event === 'changeshipcomp') {
            if (this.khaConfig.datauxview) {
              this.selectedKha = this.ctrlServ.selectedKha;
              if (data['comp'] !== undefined) {
                this.ctrlServ.selectedSysComp = data.comp;
              }
              let area = this.selectedKha.split(" ").join("").toLowerCase();
              this.khaConfig.selectedKha = area;
              this.khaConfig.khamode = "system";
              this.khaConfig.setSystemConfig(area);
              this.khaConfig.resetSubSystems();
              this.khaConfig.changeKHA(area);
              this.onChangeCameraPosition('home');
            }
          }
          if (data.event === 'toggle-struct-state') {
            let key = data['key'];
            let val = data['data'];
            this.khaConfig.struct_state_current[key] = val;
            this.khaConfig.applyDisplayRuleFor_Struct(key);
          }
          if (data.event === 'toggle-otherdecks-state') {
            let key = data['key'];
            let val = data['data'];
            this.khaConfig.otherDecks = val;
            this.khaConfig.applyDisplayRuleFor_OtherDecks();
          }
          if (data.event === 'toggle-bg') {
            let val = data['data'];
            this.khaConfig.changeBackgroundColor(val);
          }
          if (data.event === 'filter-deck') {
            // this.khaConfig.matTagClear();
            let val = data['data'];

            this.khaConfig.filter_deck = val;
            // this.khaConfig.filter_deck = val === '' ? null : val;
            // this.khaConfig.clearAllElements();
            this.khaConfig.applyDisplayRuleFor_Deck(true);
            // this.onChangeCameraPosition('home');
          }
          if (data.event === 'showhide-all-systems') {
            let val = data['data'];
            this.khaConfig.showHideSubSystemAll(val)
          }
          if (data.event == 'intensity') {
            this.setVenueLightIntensity(data.data);
          }
          if (data.event === 'reset-sub-systems') {
            this.khaConfig.resetSubSystems();
          }
          if (data.event === 'show-multiple-systems') {
            let khaList = data['data'];
            this.khaConfig.showHideMultipleSystems(khaList);
          }
          if (data.event === 'store-compartments') {
            let boo = data['data'];
            this.khaConfig.clear_compartments = !boo;
          }
          if (data.event === 'clearCompartment') {
            this.khaConfig.clearElements(data.data);
            this.khaConfig.clearCutOuts();
            this.khaConfig.clearPointer();
            this.khaConfig.clearSections();
          }
          if (data.event == "createLayout") {
            this.openLayout()
            delete this.layoutHeadingName;
            delete this.shapeCollection;
            delete this.groupCollection;
            delete this.statusCollection;
            delete this.typeCollection;
            delete this.saveLayoutData;
            delete this.pickedMeshObj
          }
          if (data.event == "layoutActive") {
            if (data.data.length == 0 && !this.selectedLayoutList) {
              this.LayoutMode = false;
              this.selectedLayoutList = data['data'];
              this.layoutName = ''
              this.layoutHeading = ''
            } else {
              this.LayoutMode = true;
              this.selectedLayoutList = data['data'];
              this.showTypeData = this.selectedLayoutList['type']
              this.drawService.layoutData = this.selectedLayoutList;
              this.layoutHeading = this.selectedLayoutList['layoutName'];
              this.layoutName = this.selectedLayoutList['layoutName'];
              this.layoutId = this.selectedLayoutList['_id'];
            }
          }
          if (data.event == "stateBoardCtrlClose") {
            var control = data.data;
            this.controlToolEvent(control);
          }
        }
        if (data.src === "khaservice") {
          if (data.event == "layoutTagOpen") {
            let layoutData = data['data'];
            let status = data['status']
            this.khaConfig.showLayoutTag(layoutData, status);
            if (this.khaConfig.layoutTagList.length > 0) {
              this.layoutTagState = true;
            } else {
              this.layoutTagState = false;
            }
          }
        }
        if (data.src === 'chit') {
          if (data.event === 'show-dockyard') {
            this.showIframeInView(data['data']);
          }
          if (data.event === 'enable-dockyard') {
            this.dockyardView = data['data'];
            this.iframeLoadData();
          }
        }
        if (data.src === "chitStepper") {
          if (data.event === 'chitActivity') {

          }
          if (data.event === 'radhaz_rhIndi') {
            let d = data['data'];
            if (d['shipId']) {
              this.radhazVisServ.showHideRHCylinder(d.shipId, d.state, d.id);
            }
          }

          /**man-aloft */
          if (data.event === 'radhaz_maIndi') {
            let d = data['data'];
            if (d['shipId']) {
              this.radhazVisServ.showHideMAIndicator(d.shipId, d.state, d.id);
            }
          }
        }
        if (data.src === "ctrlserv") {
          if (data.event === 'opendialogbox') {
            let message = data['data'];
            if (message) {
              this.openPublishDialog(message);
            }
          }
        }
      })
  }
  onSidePanelInit() {
    if (this.venue_ready) {
      this.broadcastInfo({ src: 'main', event: 'venue-ready', key: null, data: '' });
    }
  }
  ngAfterViewInit(): void {
    this.configService.loadFile('../assets/license.info').then((info) => {
      this.configService.getProjectConfig().then((project_config: any) => {
        project_config.licence = info;
        this.project_config = project_config
        this.datauxview.setProjectSettins(project_config);
        this.datauxview.loadCanvas('settings-systems', 'json', (data, settingstatus) => {

          var setting_status = settingstatus;
          if (!setting_status) {
          } else {
            this.initShipObjects();
          }
          // this.hideShipLine();
        }, (err) => { console.log(err) });
      }, (err) => { alert("License not found!") })
    })
    this.broadcastIframeSubs = this.CommunicationServ.getIframeInstance()
      .subscribe((data: any) => {
        if (data.iframeConnection === "sdms-connection") {
          if (data.event === 'loginInfo') {
            this.userId = data.data['userId'];
            this.userName = data.data['userName'];
            this.accountEmail = data.data['accountEmail'];
            this.loginInfo = data.data;
            this.configService.accessToken = data.data['accessToken'];
            this.configService.refershToken = data.data['refershToken'];
            delete this.navyFilterState;
            this.broadcastInfo({ src: 'main', event: 'navyUserInfo', key: true, data: this.loginInfo });
            this.getUserActivityInfo();
          }
        }
        if (data.iframeConnection === "sdms-connection") {
          if (data.event === 'loginInfo') {
            this.userId = data.data['userId'];
            this.userName = data.data['userName'];
            this.accountEmail = data.data['accountEmail'];
            this.loginInfo = data.data;
            this.configService.accessToken = data.data['accessToken'];
            this.configService.refershToken = data.data['refershToken'];
            delete this.navyFilterState;
            this.broadcastInfo({ src: 'main', event: 'navyUserInfo', key: true, data: this.loginInfo });
            this.getUserActivityInfo();
          }
          if (data.event == "notificationInfo") {
            var approvalStatus = data.data;
            var notificationData = data.notificationData
            this.broadcastInfo({ src: "material", event: "notificationData", data: approvalStatus, notificationData: notificationData })
          }
        }
        if (data.iframeConnection === "dockyard") {
          // if (data.event === 'loginInfo') {
          //   this.userId = data.data['userId'];
          //   this.userName = data.data['userName'];
          //   this.accountEmail = data.data['accountEmail'];
          //   this.loginInfo = data.data;
          //   this.configService.accessToken = data.data['accessToken'];
          //   this.configService.refershToken = data.data['refershToken'];
          //   delete this.navyFilterState;
          //   this.broadcastInfo({ src: 'main', event: 'navyUserInfo', key: true, data: this.loginInfo });
          //   this.getUserActivityInfo();
          // }
          // if (data.src === "navyApp") {
          if (data.event == "dockyard-loaded-iframe") {
            console.log("data loaded", data.data);
            this.iframe_cd_ready = true;
            const snack = this.snackbar.open('Dockyard data loaded!', "", { duration: 5000 });
            this.broadcastIframeInfo({ iframeConnection: 'dockyard', event: 'dockyard-shipdata-iframe', data: this.oodOfficerDetails });
          }
          if (data.event == "dockyard-init-iframe") {
            this.broadcastIframeInfo({ iframeConnection: 'dockyard', event: 'dockyard-profile-iframe', data: { email: this.oodOfficerDetails['ood_email'] } });
          }
          // }
        }
      })
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  oodPort: any;
  oodVesselName: any;
  oodVesselLocation: any;
  oodOfficerDetails
  iFrameUrl: any;
  loadingPort: any;
  getUserActivityInfo() {
    this.configService.getProjectConfig().then((project_config: any) => {
      this.chitService.getOodData().subscribe(response => {
        var oodOfficer = response.filter(t => t.ood_email == this.accountEmail);
        var oodOfficerDetails = this.oodOfficerDetails = oodOfficer[0];
        this.oodPort = oodOfficerDetails.dockyard;
        this.oodVesselName = oodOfficerDetails.vessel;
        this.oodVesselLocation = oodOfficerDetails.location;
        this.ctrlServ.userSchedule = oodOfficerDetails
        // console.log("shipLocationMatchData", shipLocationMatch) cfbhalifax cfbesquimalt &nodetree=mechanical
        // http://localhost:4201/?planType=
      })
    })
    // this.updateNotification();
  }

  //   getMessageData() {
  //   // this.notificationList = [];
  //   this.configService.getMessageData()
  //     .subscribe((response) => {
  //       console.log("message", response);
  //       if (response.result == 'success') {
  //         this.notificationList = response.notifications;
  //         if (this.notificationList.length > 0) {
  //           this.notificationList = this.notificationList.filter(data => {
  //             if (data['receiver'].length <= 0) {
  //               return data;
  //             } else if (data['receiver'].some(el => el['email'].toLowerCase() === this.accountEmail.toLowerCase())) {
  //               return data;
  //             }
  //           })
  //           this.notificationList = this.notificationList.reverse();
  //         }
  //       }
  //     },
  //       error => {
  //         console.log('Request failed with error');
  //         console.log(error)
  //       })
  // }updateNotification
  // updateNotification() {
  //   var data = {
  //     "chitId": "62bef7ab40e21322c86cfb5f",
  //     "email": "demo.dfx@outlook.com",
  //     "status": "skjdlka"
  //   }
  //   // this.configService.getProjectConfig().then((project_config: any) => {
  //   this.chitService.updateNotification(data)
  //     .subscribe((res) => {
  //       console.log("notification update", res)
  //     }, error => {
  //       console.error('There was an error!');
  //     })
  //   // })
  // }
  iframeLoadData() {
    let hostname = window.location.hostname;
    let origin = window.location.origin;
    if (this.oodPort == 'CFB Esquimalt') {

      this.loadingPort = 'CFB Esquimalt';
      if (hostname === 'localhost') {
        let url = 'http://localhost:4201/?planType=MARPAC&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      } else if (hostname === 'sdms.navy.datifex.net') {
        let url = 'https://sdms.navy.datifex.net/?planType=MARPAC&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      } else if (hostname === 'sdms.navy.datifex.com') {
        let url = 'https://sdms.navy.datifex.com/?planType=MARPAC&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      } else {
        let url = origin + '/?planType=MARPAC&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }
    if (this.oodPort == 'CFB Halifax') {
      let hostname = window.location.hostname;
      this.loadingPort = 'CFB Halifax';
      if (hostname === 'localhost') {
        let url = 'http://localhost:4201/?planType=MARLANT&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      } else if (hostname === 'sdms.navy.datifex.net') {
        let url = 'https://sdms.navy.datifex.net/?planType=MARLANT&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      } else if (hostname === 'sdms.navy.datifex.com') {
        let url = 'https://sdms.navy.datifex.com/?planType=MARLANT&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      } else {
        let url = origin + '/?planType=MARLANT&mode=collition';
        this.iFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }
  }
  venue_ready = false;
  preInitView() {
    this.socketService.init_socket(this.project_config)
    this.setVenueLightIntensity();
    this.initSystemsModel('pre');
    this.drawService.scene = this.dfx.getCamera().getScene();
    this.initialized = true;
    this.isMaterialAppLoaded = true;
    this.ctrlServ.isMaterialAppLoaded = true;
    this.vesselLoading = false;
    this.venue_ready = true;
  }
  initView() {

    this.initSystemsModel();

    this.khaConfig.hideExitRoutes();
    this.broadcastInfo({ src: 'sidepanel', event: 'showhide-ruler', key: false, data: '' });
    this.broadcastInfo({ src: 'sidepanel', event: 'showhide-fl', key: false, data: '' });
    this.changeCursor();
    this.khaConfig.showNonBlockLoading = !true;

  }
  setVenueLightIntensity(i = 4) {
    this.lightSettings = [{ direction: { x: -0.85, y: -0.40, z: 0.35 }, diffuse: { r: 0.65, g: 0.65, b: 0.65 }, specular: { r: 0, g: 0, b: 0 } }, { direction: { x: 0.75, y: -0.40, z: -0.45 }, diffuse: { r: 1.0, g: 1.0, b: 1.0 }, specular: { r: 0, g: 0, b: 0 } }, { direction: { x: 0.15, y: -0.40, z: 0.50 }, diffuse: { r: 1.0, g: 1.0, b: 1.0 }, specular: { r: 0, g: 0, b: 0 } }];
    this.dfx = this.datauxview.getDatascape();
    this.scene = this.dfx.getCamera().getScene();
    let lights = this.scene.lights;
    lights.forEach((light) => {
      light.intensity = i;
    })
  }
  allElements = [];
  radhaz_comps = {
    "01__NAV_RADAR-B": { "antenna": true, "rotating": true, "position": { "x": -2.81, "y": 21.17, "z": -18.81 }, "radius": 2, "height": null, "state": false, "name": "NAV RADAR B", "id": "NAV_radar_B", "index": 1 },
    "02__NAV_RADAR-A": { "antenna": true, "rotating": true, "position": { "x": 0, "y": 12.6, "z": -33.72 }, "radius": 3, "height": null, "state": false, "name": "NAV RADAR A", "id": "NAV_radar_A", "index": 2 },
    "11__SIRIUS": { "antenna": false, "rotating": true, "position": { "x": 0, "y": 24.05, "z": -18.79 }, "radius": 0.8, "height": null, "state": false, "name": "SIRIUS", "id": "SIRIUS_sensors", "index": 11 },
    "16__FBB-500": { "antenna": true, "rotating": false, "position": { "x": 0.94, "y": 14.32, "z": 27.3 }, "radius": 2, "height": null, "state": false, "name": "FBB 500", "id": "FBB_500", "index": 16 },
    "31__SG-180": { "position": { "x": 0, "y": 23.4, "z": -15 }, "radius": 17, "height": null, "state": false, "name": "SG-180", "id": "SG-180", "index": 31, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": true }, "43__RAMSES": { "position": { "x": 0, "y": 14.79, "z": -17 }, "radius": 35, "height": null, "state": false, "name": "RAMSES", "id": "RAMSES", "index": 43, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "44__NMT_PORT": { "position": { "x": -4.13, "y": 13.15, "z": 17.7 }, "radius": 45, "height": null, "state": false, "name": "NMT PORT", "id": "NMT_PORT", "index": 44, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "45__NMT_STBD": { "position": { "x": 4.13, "y": 13.15, "z": 17.7 }, "radius": 45, "height": null, "state": false, "name": "NMT STBD", "id": "NMT_STBD", "index": 45, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "46__CEROS_200_fwd": { "position": { "x": 0, "y": 13.8, "z": -30.63 }, "radius": 75, "height": null, "state": false, "name": "FWD CEROS", "id": "CEROS_200_fwd", "index": 46, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": true }, "47__CEROS_200_aft": { "position": { "x": 0, "y": 16.86, "z": 18.01 }, "radius": 75, "height": null, "state": false, "name": "AFT CEROS", "id": "CEROS_200_aft", "index": 47, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": true }, "48__SEOSS": { "position": { "x": -4.52, "y": 11.99, "z": -33.56 }, "radius": 66, "height": null, "state": false, "name": "SEOSS", "id": "SEOSS", "index": 48, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "49__Smart_S_radar": { "position": { "x": 0, "y": 17.85, "z": -25 }, "radius": 30.4, "height": null, "state": false, "name": "Smart-S", "id": "Smart_S_radar", "index": 49, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": true }, "60__white_Sailor_100_GX": { "position": { "x": 1.27, "y": 12.37, "z": 23.24 }, "radius": 55, "height": null, "state": false, "name": "Sailor 100 GX", "id": "Sailor_100_GX", "index": 60, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "54__MSCU": { "position": { "x": 0.26, "y": 14.45, "z": 25.37 }, "radius": 153, "height": null, "state": false, "name": "lMSCU", "id": "lMSCU", "index": 54, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "55__CIWS_sensors": { "position": { "x": 3.86, "y": 13.63, "z": 33.51 }, "radius": 189, "height": null, "state": false, "name": "CIWS RF ONLY", "id": "CIWS_sensors", "index": 55, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": true }, "56__HF_18ft_whip": { "position": { "x": -0.08, "y": 0.05, "z": 0 }, "radius": 18.5, "height": null, "state": false, "name": "HF 18' Whip", "id": "HF_18ft_whip", "index": 56, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "56__HF_35ft_whip": { "position": { "x": -0.08, "y": 0.05, "z": 0 }, "radius": 10, "height": null, "state": false, "name": "HF 35' Whip", "id": "HF_35ft_whip", "index": 56, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "57__HF_Emergency": { "position": { "x": 4.33, "y": 17.67, "z": 8.27 }, "radius": 7.3, "height": null, "state": false, "name": "HF Emergency", "id": "HF_Emergency", "index": 57, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "58__CEROS_200_fwd": { "position": { "x": 0, "y": 13.8, "z": -30.63 }, "radius": 245, "height": null, "state": false, "name": "FWD CWI", "id": "CEROS_200_fwd", "index": 58, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }, "59__CEROS_200_aft": { "position": { "x": 0, "y": 16.86, "z": 18.01 }, "radius": 245, "height": null, "state": false, "name": "AFT CWI", "id": "CEROS_200_aft", "index": 59, "matid": "dfx_#FFA500", "matid2": "dfx_#ffff00_transparent", "matid3": "dfx_#00ff00_transparent", "matid4": "dfx_#337e9f_transparent", "matid5": "dfx_#aaEEaa_transparent", "antenna": true, "rotating": false }
  }
  /**
   * hardcode emitter position with offset z=-65.5,y=5.5
   */
  applyEmitterOffsets() {
    let keys = Object.keys(this.radhaz_comps);
    keys.forEach((k) => {
      this.radhaz_comps[k].position.z -= 65.5;
      this.radhaz_comps[k].position.y += 5.85;
    })
  }
  /**
   * init system model
   */
  initSystemsModel(m = null) {
    if (m === 'pre') {
      window['sys_scope'] = this;
      this.khaConfig.scene = this.scene;
      this.tagServ.scene = this.scene;
      this.khaConfig.game_engine = this.scene.getEngine();
      this.khaConfig.dfx = this.dfx;
      this.drawService.cfbport = 'ehfx'
      this.khaConfig.datauxview = this.datauxview;
      this.drawService.datauxview = this.datauxview;
      this.drawService.dfx = this.dfx;
      this.dfx = this.datauxview.getDatascape();
      this.allElements = this.datauxview.getElementsid();
      this.tagServ.init(this.datauxview);
      this.ctrlServ.init(this.datauxview);
      this.tagServ.datauxview = this.datauxview;
      this.tagServ.port = this.cfbport;
    }
    if (this.mvScreenType == 'system') {
      this.processHFX();
      if (this.selectedKha) {
        let sys = this.selectedKha.split(" ").join("").toLowerCase();
        this.khaConfig.initSystems(sys);
      }
    }
    if (this.mvScreenType == "compartment") {
      if (this.slms_mode) {
        this.processHFX_slms();
        this.khaConfig.slms_mode = this.slms_mode;
        let ehfx = this.datauxview.getElementId('ehfx');
        let hfx = this.dfx.getElementMesh(ehfx)
        this.khaConfig.khasystemship = hfx.getChildren()[0];
        this.khaConfig.getSysDefalutPosition(this.khaConfig.khasystemship);
        this.khaConfig.applyDisplayRule_Struct(false, this.khaConfig.struct_state_slms_1);
        this.khaConfig.applyDisplayRuleFor_Deck();
        //
        if (m !== null) {
          this.radhazVisServ.radhaz_comps = this.radhaz_comps
          this.activityServ.init(this.datauxview);
          this.radhazVisServ.initService(this.datauxview, this.CommunicationServ, this.activityServ);
          this.radhazVisServ.createBasicShapes()
          this.applyEmitterOffsets();
          this.radhazVisServ.addRadHazActivity({ name: 'ehfx' }, false);
          this.radhazVisServ.addRadHazActivity({ name: 'ehfx' }, false, "ARH");
          this.radhazVisServ.addRadHazActivity({ name: 'ehfx' }, false, "ROT");
          let ealoft = this.datauxview.getElementId('ealoft');
          let ealoft_m = ealoft ? this.dfx.getElementMesh(ealoft) : null;

          this.radhazVisServ.processHFXForRHMAT(null, ealoft_m);
          this.radhazVisServ.processHFXForRH('ealoft', this.radhazVisServ['aloft_comps_ehfx'], true);
          this.dfx.setAsParent(ehfx, [ealoft]);

          // this.broadcastInfo({ src: 'main', event: 'venue-ready', key: null, data: '' });
        } else {
          this.reassignEnvelopes(ehfx);
        }
      }
      this.khaConfig.processandloadComparment();
    }

  }
  reassignEnvelopes(ship = null) {
    let ealoft = this.datauxview.getElementId('ealoft');
    let c1 = this.radhazVisServ.getCylindersOfActs(this.radhazVisServ.activityServ.radhaz_cylinders['ehfx'])
    let c2 = this.radhazVisServ.getCylindersOfActs(this.radhazVisServ.activityServ.ant_radhaz_cylinders['ehfx'])
    let c3 = this.radhazVisServ.getCylindersOfActs(this.radhazVisServ.activityServ.ant_rot_cylinders['ehfx'])
    let cylinders = [].concat(c1, c2, c3);
    this.dfx.setAsParent(ship, [ealoft]);
    this.dfx.setAsParent(ship, cylinders);
  }
  processHFX_slms() {
    let ehfx = this.datauxview.getElementId("ehfx");
    let hfx = this.dfx.getElementMesh(ehfx);
    hfx.scaling.z = -1;
    this.processShipMaterial();

    hfx.getChildren()[0].getChildMeshes().forEach((mesh) => {
      let mat = mesh.material ? mesh.material.name : "";
      mesh.mid = mat;
    })
  }
  processHFX() {
    let ehfx = this.datauxview.getElementId("ehfx");
    let hfx = this.dfx.getElementMesh(ehfx);
    hfx.scaling.z = -1;
    hfx.getChildren()[0].setEnabled(false);
    let scene = this.scene;
    this.processShipMaterial();
    hfx.getChildren()[1].getChildMeshes().forEach((mesh) => {
      let mat = mesh.material ? mesh.material.name : "";
      mesh.mid = mat;
    })
  }
  processShipMaterial() {
    this.scene.materials.forEach((mat) => {
      if (mat.getClassName().includes("PBR")) {
        mat.specularIntensity = 0;
        mat.metallic = 0;
        mat.roughness = 1;
        mat.ambientColor = this.dfx.color3([1, 1, 1]);
      }
    })
  }
  initShipObjects() {
    this.tagServ.init(this.datauxview);

    this.initObjects(() => {
      if (this.mvScreenType == 'system') {
        this.loadShipObjects((boo) => {
          this.getMaterialStatusData(() => {
            this.initView()
          })
        })
      }
      if (this.mvScreenType == "compartment") {
        if (this.slms_mode) {
          this.loadShipThumbObjects((boo) => {
            this.preInitView();
            this.khaConfig.showNonBlockLoading = true;
            this.loadShipObjects((boo) => {
              this.initView();
            }, this.ship_settings_slms)
          }, this.ship_settings_slms_thumb)
        } else {
          this.initView()
        }
      }
    })
  }
  /* * *
* load dynamic ship settings and objects
* * */

  loadShipObjects(cbck = null, settings = null) {
    this.dfx.addDynamicShapes(settings || this.ship_settings).then(() => {
      let shapes = this.ship_objects['shapes'];
      let objects = this.ship_objects['objects'];
      this.datauxview._createModels(shapes, (boo) => {
        let ehfx = this.datauxview.getElementId('ehfx');
        if (ehfx) {
          this.reassignEnvelopes();
          this.dfx.remove(ehfx);
        }
        this.datauxview.addElements(objects, (portObjects) => {
          if (cbck) {
            this.allShipElements = portObjects;
            this.ctrlServ.hideElement("ernhfx");
            let ernhfx = this.ctrlServ.getMesh("ernhfx");
            ernhfx.rotationQuaternion = null;
            cbck(true);
          }
        }, (id, pointer) => { })
      }, (id, pointer) => { })
    });
  }
  loadShipThumbObjects(cbck = null, settings = null) {
    this.dfx.addDynamicShapes(settings || this.ship_settings).then(() => {
      let shapes = this.ship_objects_thumb['shapes'];
      let objects = this.ship_objects_thumb['objects'];
      this.datauxview._createModels(shapes, (boo) => {
        this.datauxview.addElements(objects, (portObjects) => {
          if (cbck) {
            cbck(true);
          }
        }, (id, pointer) => { })
      }, (id, pointer) => { })
    });
  }

  /* * * * *
* init objects
* loading all the static objects from objects.json
* * * * * */
  initObjects(cbck) {
    this.datauxview.loadAssets('objects-systems', 'json', (objectstatus) => {
      if (objectstatus) {
        this.datauxview.renderAssets('objects-systems', 'json', (objectstatus) => {
          if (objectstatus) {
            this.dfx = this.datauxview.getDatascape();
            if (window.innerWidth < 1024) {
              this.datauxview.getDatascape().moveCamera({ distance: 200 });
            }
            this.ctrlServ.init(this.datauxview);
            cbck();
          }
        }, () => { })
      }
    });
  }

  /* * *
  * method for get material status data from server
  * * */
  getMaterialStatusData(cbck) {
    this.khaConfig.MaterialStatusData = [];
    this.configService.getMaterialStatusData().then((data: any) => {
      if (data) {
        this.khaConfig.MaterialStatusData = data;
        console.log("MaterialStatusData ", this.khaConfig.MaterialStatusData);
        cbck()
      } else {
        console.log('MaterialStatusData data not found !!');
        cbck()
      }
    }).catch((error) => {
      console.log("error ", error);
      cbck();
    });
  }
  hideShipLine() {
    this.khaConfig.showHideRuler(false);
    this.khaConfig.showHideFramesAndLongs(false);
    // this.broadcastInfo({ src: 'sidepanel', event: 'showhide-ruler', key: false, data: '' });
    // this.broadcastInfo({ src: 'sidepanel', event: 'showhide-fl', key: false, data: '' });
  }
  /**
    * onChange camera mode
    * * */
  onChangeCameraMode(camView) {
    this.cam_mode = camView;
    if (this.cam_mode == '2D') {
      this.onChangeCameraPosition('top');
    }
    this.datauxview.CameraMode(camView);
    if (this.cam_mode == '3D') {
      if (this.khaConfig.khamode === 'system') {
        setTimeout(() => {
          this.onChangeCameraPosition('home');
        }, 1300);
      }
    }
  }

  /**
  * onChange camera position
  * * */
  onChangeCameraPosition(camView) {
    if (camView === 'home') {
      this.onChangeCamView(camView);
    }
    if (this.cam_mode == '2D') {
      camView = 'ortho' + camView
    }
    this.datauxview.Camera(camView);
  }

  /**
  * onChange camera view
  */
  onChangeCamView(v, vobj = false) {
    let currentTab = this.ctrlServ.matCurrentTab;
    if (currentTab !== 'section') {
      this.moveCameraTo(null, v)
    }
  }

  /**
  * move camera
  */
  moveCameraTo(el, view = null) {
    let dfx = this.datauxview.getDatascape();
    let _view = view;
    // if(dfx!=null){
    dfx.moveCamera(_view);
    // }

  }

  canvasPickedObject(e) {
    const hit = this.dfx.getHitPosition();
    if (!hit.hit) {
      return;
    }
    if (this.dfx) {
      console.log("-----", hit, hit.pickedMesh.id);
      delete this.saveNotesData.status;
      var mesh = hit.pickedMesh;
      var pmesh;
      var mesh = hit.pickedMesh;
      if (mesh != null && this.doubleClick === 0) {
        if (mesh.name.includes('_slicer') && mesh.name.includes('marker_')) {
          console.log(" mesh.name ", mesh);
          this.drawService.selectedMarker = mesh.name.split("_slicer")[0];
          if (Object.keys(this.drawService.cselects).length === 0) return;
          let markerObj = this.drawService.cselects[this.drawService.selectedMarker];
          this.markerColor = markerObj[7] || "#ff0000";
          this.fillStatus = !!(markerObj[9])
          this.drawService.draw_select_fill = this.fillStatus;
          let obj = { mname: this.drawService.selectedMarker, markerData: this.drawService.getCutMarkersData(), location: { x: mesh.position.x, y: mesh.position.y, z: mesh.position.z } }
          this.broadcastInfo({ src: 'ship-detail', event: 'open-defects-notes-popup', data: obj, key: "" });
        }
        if (this.drawService.cut_mode || this.drawService.draw_select_mode) {
          if (this.markerShape === 'polygon' && this.drawing) {
            return;
          }
        }
        let str = mesh.name
        let narr = str.split(".");
        if (narr.length > 0) {
          if (narr[0].includes('layout')) {
            let tagMesh = narr[0].split('-')[1];
            let tagId = narr[0].split('_')[1];
            console.log(this.tagServ.showHideTagPointer);
            if (this.tagServ.showHideTagPointer.length > 0 && this.tagServ.showHideTagPointer.includes(tagMesh)) {
              this.broadcastInfo({ src: 'main', event: 'tagEvent', data: tagId, key: false });
            } else {
              this.broadcastInfo({ src: 'main', event: 'tagEvent', data: tagId, key: true });
            }
            return;
          } else {
            if (mesh.name.includes('envelope')) {
              console.log("envelope", "radiate");
              let objId = mesh.name.replace('element-', '');
              // if(radiateData.length==7){
              //   let shipId = radiateData[3].split('.')[0];
              //   var objId =  radiateData[1]+'-'+radiateData[2]+'-'+shipId;
              // }
              // if(radiateData.length==9){
              //   let shipId = radiateData[4].split('.')[0];
              //    objId =  radiateData[1]+'-'+radiateData[2]+'-'+shipId;
              // }
              if (this.activityServ.radhaz_cylinders['ehfx'][objId]) {
                var elem = this.datauxview.getDatascape().props(this.activityServ.radhaz_cylinders['ehfx'][objId])

              }
              if (this.activityServ.ant_radhaz_cylinders['ehfx'][objId]) {
                var elem = this.datauxview.getDatascape().props(this.activityServ.ant_radhaz_cylinders['ehfx'][objId])
              }
              if (this.activityServ.ant_rot_cylinders['ehfx'][objId]) {
                var elem = this.datauxview.getDatascape().props(this.activityServ.ant_rot_cylinders['ehfx'][objId])
              }

              console.log("envelope-radiate", objId, elem);
              if (elem) {
                this.broadcastInfo({ src: 'main', event: 'tagEvent', data: elem, key: true, activity: 'radiate' });
              }

              return;
            } else if (mesh.name.includes('ealoft')) {
              console.log("ealoft", "man-aloft");
              // let objId = mesh.name.replace('element-','');
              let radiateData = mesh.id.split('.');
              if (radiateData.length == 6) {
                let shipId = radiateData[5];
                // var objId =  radiateData[1]+'-'+radiateData[2]+'-'+shipId[0];
                var manAloftList = this.radhazVisServ.getAloft(shipId);
                var mmel = this.radhazVisServ.getChildMeshEx('ehfx', shipId)
                console.log(manAloftList, mmel);
              }
              if (mmel) {
                this.broadcastInfo({ src: 'main', event: 'tagEvent', data: mmel, key: true, activity: 'manAloft' });
              }
              return;
            }
          }
        }

      }
      let mname = this.ctrlServ.getMeshName(mesh.name);
      let str = mesh.name
      let narr = str.split(".");
      let nstr = narr[narr.length - 1];
      let uid = this.getUIDData();
      if (!this.selectedLayoutList || this.selectedLayoutList.length == 0) {
        var shapeId = 'cube'
      } else {
        shapeId = this.selectedLayoutList.shapeId
      }
      this.pickedMeshObj = { tagShapeId: uid, shapeId: shapeId, position: { x: hit.pickedPoint.x, y: hit.pickedPoint.y, z: hit.pickedPoint.z }, parentMeshId: nstr, port: 'slms' };

      console.log("--mesh---", pmesh, this.pickedMeshObj);
      this.selectedTagItem = this.pickedMeshObj;
      this.saveNotesData = {}
      this.saveNotesData['group'] = { 'name': "Group Name", "color": "#BDBDBD" }
      this.saveNotesData['status'] = { 'name': "Status Name", "value": "#BDBDBD" }
      this.broadcastInfo({ src: 'tagPoint', event: 'defaultColor', data: this.saveNotesData, key: this.selectedTagItem });
      // this.tagServ.createMatObject("cube", hit, mname);
      // console.log("--mesh---", pmesh, this.pickedMeshObj);
      this.selectedTagItem = this.pickedMeshObj;
      return;
    }
    // console.log("-----", hit.pickedPoint, hit.pickedMesh.id)
    const hpt = hit.pickedPoint;
    console.log("Picked Point main : ", hit.pickedPoint)
    console.log("Picked Point: ", hpt.x, hpt.z)
    if (this.last_pick_pt) {
      let dx = hpt.x - this.last_pick_pt.x;
      let dy = hpt.z - this.last_pick_pt.z;
      let rad = Math.atan2(dy, dx);
      let deg = rad * 180 / Math.PI;
      let ds = Math.sqrt(dx * dx + dy * dy)
      console.log("Picked Angle: ", rad.toFixed(4), deg.toFixed(4));
      console.log("Picked Distance: ", ds.toFixed(4));
    }
    this.last_pick_pt = hpt;
  }
  getUIDData() {
    return Math.random().toString(36).substr(2, 9);
  }

  getUserData() {
    this.configService.getProjectConfig().then((project_config: any) => {
      this.projectConfig = project_config;
      this.chitService.getUserData().subscribe(
        (response) => {
          this.usersDetails = response;
        },
        error => {
          console.error('Request failed with error')
        })
    })
  }

  getSelectedKhaSystemsLabel(e, a) {
    this.selectedKhaSystems = { color: "#00000000" };
    let code = a[1] ? ((a[0].split("_")[1])) : "--";
    let desc = a[1] ? (a[1]) : a[0];
    let mat = e.mid;
    this.selectedKhaSystems.id = e['id'];
    this.selectedKhaSystems.code = code;
    this.selectedKhaSystems.desc = desc;
    this.mname = this.ctrlServ.getMeshName(e['id']);
    let floorColor = this.khaConfig.checkDeckFloor(this.mname);
    this.highlightCompState = floorColor;
    this.componentLoad()
    console.log("floor", floorColor)
    let _mesh = this.selectedMesh;
    if (this.selectedMesh.name.includes("_slicer") || this.selectedMesh.name.includes("_marker")) {
      _mesh = null;
    }
    if (_mesh) {
      this.khaConfig.highlightSelection(_mesh, 4, null, true, floorColor);
    }
    if (this.materialmap[mat]) {
      this.selectedKhaSystems.color = this.materialmap[mat]
    }
    if (this.statusMode) {
      let colors = { "red": "#ff0000", "yellow": "#ffff00", "transparent": "#ababb2" };
      let statusColor = this.getStatusColorCode(e['id']);
      if (statusColor) {
        this.selectedStatus = statusColor;
        let color = colors[statusColor];
        this.materialmap[mat] = color;
        this.selectedKhaSystems.color = color;
      }
    } else {
      if (mat && !this.materialmap[mat]) {
        let m = this.scene.getMaterialByName(mat);
        let c = m.albedoColor;
        let r = Math.round(c.r * 255);
        let g = Math.round(c.g * 255);
        let b = Math.round(c.b * 255);
        let hex = this.rgbToHex(r, g, b);
        this.materialmap[mat] = hex;
        this.selectedKhaSystems.color = hex;
      }
    }
  }
  getUID() {
    return Math.random().toString(36).substr(2, 9);
  }
  getStatusColorCode(id) {
    let material;
    for (let mat of Object.keys(this.khaConfig.systemSubComps)) {
      let comps = this.khaConfig.systemSubComps[mat];
      const found = comps.some(m => m.id === id);
      if (found) {
        material = mat;
        break;
      }
    }
    return material;
  }

  /**
  * Zoom event to zoom in / out the venue
  */

  Zoom(key) {
    this.isMouseDown = true;
    this.datauxview.startZoom(key);
  }
  stopZoom() {
    this.isMouseDown = !true;
    this.datauxview.stopZoom();
  }
  @HostListener('document:pointerdown', ['$event'])
  handlePointerDownEvent(event: MouseEvent) {
    this.mousestate = "down";
    if (event.target['nodeName'] === 'CANVAS') {
      if (!this.gameManager) {
        this.onMouseDownN();
      }
      let drawaction = (this.drawService.draw_select_mode || this.drawService.cut_mode) && !this.drawService.marker_select_mode
      if (drawaction && (event.which === 1 || event.button === 0)) {
        let dr = this.drawService.doDraw()
        this.drawing = dr;
      }
      // for color picker tool outside close
      let dom: any = document.getElementsByClassName("btn btn-custom-ok")[0];
      if (dom) {
        dom.click();
      }
    }
  }
  @HostListener('document:pointermove', ['$event'])
  handlePointereMoveEvent(event: MouseEvent) {
    if (event.target['nodeName'] === 'CANVAS') {
      if (this.mousestate === 'down') {
        this.mousestate = "drag";
      }
      if (this.mousestate === 'drag') {
        let drawaction = (this.drawService.draw_select_mode && this.markerShape != 'polygon') || this.drawService.cut_mode
        if (drawaction && this.drawing) {
          this.drawService.doDraw()
        }
      }
    }
    // this.onMouseMoveN(event)
  }
  @HostListener('document:pointerup', ['$event'])
  handlePointereUpEvent(event: MouseEvent) {
    if (this.mousestate === 'down') {
      if ((<HTMLInputElement>event.target).id == "renderCanvas") {
        if (event.which === 1 || event.button === 0) {
          if (!this.gameManager) {
            setTimeout(() => {
              if (this.ctrlServ.isAddLocationState) {
                this.getPickedLocation(event);
              } else {                
                this.canvasPickedObject(event);
              }
            }, 201)
          }
        }
      }
    }
    if ((<HTMLInputElement>event.target).id == "renderCanvas") {
      if (this.drawing) {
        let drawaction = this.drawService.draw_select_mode || this.drawService.cut_mode
        if (drawaction && this.drawing) {
          let dr = this.drawService.stopDraw()
          this.drawing = dr;
        }
      }
      if (!this.gameManager) {
        this.onMouseUpN();
      }
    }
    this.mousestate = "up";
  }

  @HostListener('document:mouseup', ['$event'])
  handleMouseUpEvent(event: MouseEvent) {
    if (this.isMouseDown) {
      this.stopZoom();
    }
    this.mousestate = "up"
  }

  onMouseDownN(d = 1) {    
    this.doubleClick += 1;   
  }

  onMouseUpN() {
    setTimeout(() => {
      this.doubleClick = 0;     
    }, 200);
  }
  rgbToHex(r, g, b) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }
  /**
 * utility functions
 */
  private componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  componentLoad() {
    console.log(this.selectedKhaSystems)
    const filterData = this.ctrlServ.shipComp['compList'].filter(el => el.code === this.mname)
    console.log(filterData)
    this.compartmentLoad = filterData[0];
  }
  compartmentLoads() {
    this.broadcastInfo({ src: 'slmsSidepanel', event: 'compartmentLoad', data: this.compartmentLoad });
  }
  openLayout() {
    this.layoutModel = true;
  }

  layoutHeading: any = "";
  layoutName: any;
  LayoutMode: any = false;
  layoutId: any;
  saveNotesData: any = {};
  layoutTagState: any = false;
  showTypeData: any;
  selectedTagItem: any;
  layoutModel: boolean = false;
  ernCardHeight: any = 200;
  iframe_width_def: number = 1;
  iframe_height_def: number = 1;
  iframe_width: number = this.iframe_width_def;
  iframe_height: number = this.iframe_height_def;
  calculateHeight(item, ifr: any, pos: any) {
    if (ifr) {
      let elem = document.getElementById('iframeNode');
      if (elem) {
        if (pos == 'height') {
          return elem.offsetHeight / 1.1;
        }
        if (pos == 'width') {
          // return elem.offsetWidth/1.1;
        }
      }


    } else {
      if (item['btext']) {
        let quizNode = ['TP 005.01.03.003', 'TP 005.01.03.002'];
        if (quizNode.includes(item['btext'].trim())) {
          this.ernCardHeight = 220;
          return true;
        } else {
          return false;
        }
      }
    }
  }
  showIframeInView(boo) {
    if (boo) {
      this.iframeInView = true;
      this.iframe_width = 600;
      this.iframe_height = 480;
    } else {
      this.iframeInView = !true;
      this.iframe_width = this.iframe_width_def;
      this.iframe_height = this.iframe_height_def;
    }
  }
  onresize(ev) {
    console.log("ON RESIZE", ev);
  }
  sel_act = [];
  showActivityEnvelope(activity, emitterlocation, boo) {
    let _shipId = 'ehfx';
    let emitter = this.radhazVisServ.isRHEmitter(activity.toLowerCase())
    if (emitter) {
      this.radhazVisServ.showHideRHCylinder(_shipId, boo, emitterlocation)
    } else if (activity.toLowerCase() === 'man-aloft') {
      this.radhazVisServ.showHideMAIndicator(_shipId, boo, emitterlocation)
    } else {
      //
    }
  }

  /* *
  * popup component
  * * */
  openPublishDialog(e): void {
    let width = '285px';
    let type = 'error';
    if (e == 'publish') {
      type = 'publish';
      width = '350px'
    }
    if (e == 'confirm-popup') {
      type = 'confirm-popup';
    }
    if (e == 'confirm-box') {
      type = 'confirm-box';
      width = '430px'
    }
    if (e == 'collision-confirm-box') {
      type = 'collision-confirm-box';
    }
    if (e == 'daterange-confirm-box') {
      type = 'daterange-confirm-box';
    }
    const dialogRef = this.dialog.open(PopupDialog, {
      panelClass: 'full-width-dialog',
      width: width,
      data: { value: '', error: e, type: type, port: this.cfbport },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /***
   * method for change cursor pointer
   */
  changeCursor() {
    let anim = (t) => {
      let curs = this.datauxview.rendererCanvas.nativeElement;
      curs.style.cursor = this.ctrlServ.isAddLocationState ? "crosshair" : "pointer";
      requestAnimationFrame(anim)
    }
    requestAnimationFrame(anim)
  }

  /***
   * method for get picked location
   */
  getPickedLocation(e) {
    const hit = this.dfx.getHitPosition();
    if (!hit.hit) {
      return;
    }
    if (this.dfx) {
      var mesh = hit.pickedMesh;
      if (mesh != null && this.doubleClick === 0) {
        let mname = this.ctrlServ.getMeshName(mesh.name);
        let position = { x: hit.pickedPoint.x, y: hit.pickedPoint.y, z: hit.pickedPoint.z };
        console.log("picked mesh name:: ", mname);
        console.log("picked position :: ", position);
        let obj = { mname, position };

        this.broadcastInfo({ src: 'ship-detail', event: 'set-' + this.ctrlServ.isActiveLayout + '-picked-location', data: obj });
        if (position) {
          setTimeout(() => {
            this.broadcastInfo({ src: 'ship-detail', event: 'babcock_sendLocation', data: obj });
          }, 100);
        }
      }
    }
  }

}

export interface PopupData {
  value: any;
  error: any;
  type: any;
  port: any;
}

/* *
* popup component
* * */
@Component({
  selector: 'dialog-popup',
  templateUrl: 'dialog-popup.html',
})

export class PopupDialog {
  broadcastSubs: any;
  broadcastInfo: any;

  constructor(private communicationServ: CommunicationService, public dialogRef: MatDialogRef<PopupDialog>, @Inject(MAT_DIALOG_DATA) public data: PopupData) {
  }

  /* * * * *
  * Init service data load
  * * * * * */
  ngOnInit() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
      })
  }

  closeClick(): void {
    this.dialogRef.close();
  }
}


